import type { Feed } from '@/types/feed.type'

import { toast } from 'sonner'
import axios from '@/lib/axios'
import { endpoints } from '@/lib/axios'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import LoadingSection from '@/components/loading-indicator/loading-section'

import FeedCard from '../feed-card'
import { FeedCommentSection } from '../feed-comment-section'

export default function FeedDetailView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [feed, setFeed] = useState<Feed | undefined>(undefined)
  const isEditMode = params.id !== undefined

  const fetchFeed = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axios.get<Feed>(endpoints.feeds.byId(params.id))
      setFeed(data)
    } catch (error) {
      console.error(error)
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchFeed()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value}>
      {feed && (
        <div>
          <FeedCard feedId={feed.id} feed={feed} />
          {/* Comments Section */}
          <FeedCommentSection feedId={feed.id} handleUpdate={fetchFeed} />
        </div>
      )}
    </LoadingSection>
  )
}
